import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { AnchorEmbeddedCustomAlert } from './anchor-embedded-custom-alert';
import { goToOrderDetails } from '../../../../../store/orders/order-details/orders.details.actions';

export const LocalDeliveryExceptionAlert = ({ content, orderNumber, salesOrderId }) => {
  const dispatch = useDispatch();
  const onClick = useCallback(() => dispatch(goToOrderDetails({ salesOrderId })), [dispatch, salesOrderId]);
  return <AnchorEmbeddedCustomAlert content={content} onClick={onClick} orderNumber={orderNumber} />;
};

LocalDeliveryExceptionAlert.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
  orderNumber: PropTypes.number.isRequired,
  content: PropTypes.string.isRequired,
};
